import { FC, JSX, ReactNode } from 'react';
import styles from './DefinitionList.scss';
import classNames from 'classnames';

type DlProps = {
  children: ReactNode;
  className?: string;
} & JSX.IntrinsicElements['dl'];

export const Dl: FC<DlProps> = ({ children, className }) => {
  return <dl className={classNames(styles.dl, className)}>{children}</dl>;
};

type DtProps = {
  children: ReactNode;
  className?: string;
} & JSX.IntrinsicElements['dt'];

export const Dt: FC<DtProps> = ({ children, className }) => {
  return <dt className={classNames(styles.dt, className)}>{children}</dt>;
};

type DdProps = {
  children: ReactNode;
  className?: string;
} & JSX.IntrinsicElements['dd'];

export const Dd: FC<DdProps> = ({ children, className }) => {
  return <dd className={classNames(styles.dd, className)}>{children}</dd>;
};
